export const deepClone=(data)=> {
    const clonedData = JSON.parse(JSON.stringify(data));
    return clonedData;
  }